import {
  validateDisclaimer,
  validateUserName,
  validate100TextArea,
  validateCurrentRevenue,
  validateDpiitNumber,
  validateSelectField,
  validateSelectFieldMulti,
  validateEmail,
  validateFile,
  validateNumber,
  validatelCountrySate,
  validatelCountry,
  validatelMobileNo,
  validateDesignation,
  validateName,
  validateUrl,
  validateCity,
} from "../common/dependencies/utils/validation";

export default {
  validateStep1: (params) => {
    const { entity_name, applicant_name, dpiit_no } = params;
    //
    let formStatus = {};
    const EntitynameStatus = validateName(
      entity_name,
      "Please Enter Entity Name"
    );
    const applicantStatus = validateName(
      applicant_name,
      "Please Enter Valid Applicant Name"
    );
    const DpiitStatus = validateDpiitNumber(
      dpiit_no,
      "Please Enter Dpiit Number"
    );

    formStatus = {
      entityName: EntitynameStatus.error,
      applicant_name: applicantStatus.error,
      dpiitNo: DpiitStatus.error,

      // sector: SectorStatus.error,
      // industry: IndustryStatus.error,
      // stage: StageStatus.error,
      hasErrors:
        EntitynameStatus.hasError ||
        applicantStatus.hasError ||
        DpiitStatus.hasError,
    };
    // //
    return formStatus;
  },

  validateStep2: (params) => {
    //
    const { email_id, contact_no, designation, gender, country, state, city } =
      params;
    let formStatus = {};
    const emailStatus = validateEmail(
      email_id,
      "Please Enter Valid Email Address"
    );
    const contactNoStatus = validatelMobileNo(
      contact_no,
      "*Please Enter Contact No"
    );
    
    const currentDesgnationStatus = validateDesignation(
      designation,
      "Please Enter Current Designation"
    );

    const genderStatus = validatelCountry(gender, "*Please Select Gender");
    const countryStatus = validatelCountry(country, "*Please Select Country");
    const StateStatus = validatelCountry(state, "Please Select State");
    // const cityStatus = validateName(city, "Please Enter City ");
    const cityStatus = validateCity(city, "Please Enter City ");
    // const applicantUrlStatus = validateName(city, "Please Enter City ");
    

    formStatus = {
      email_id: emailStatus.error,
      contact_no: contactNoStatus.error,
      designation: currentDesgnationStatus.error,
      gender: genderStatus.error,
      country: countryStatus.error,
      state: StateStatus.error,
      city: cityStatus.error,

      hasErrors:
        emailStatus.hasError ||
        contactNoStatus.hasError ||
        countryStatus.hasError ||
        currentDesgnationStatus.hasError ||
        genderStatus.hasError ||
        StateStatus.hasError ||
        cityStatus.hasError,
    };
    
    return formStatus;
  },

  validateStep3: (params) => {
    const {
      AppLindin_url,
      startupwebsite,
      startup_video_url,
      current_revenue,
    } = params;
    let formStatus = {};
    const linkedinUrlStatus = validateUrl(AppLindin_url, "Please Enter Valid Url (e.g. prefix with http:// or https://)");

    const startupwebsiteStatus = validateUrl(
      startupwebsite,
      "Please Enter Valid Startup Website (e.g. prefix with http:// or https://)"
    );
    const startupUrlStatus = validateUrl(startup_video_url, "Please Enter Valid Url (e.g. prefix with http:// or https://)");
    const currentrevenueStatus = validateCurrentRevenue(
      current_revenue,
      "Please Enter current revenue"
    );

    formStatus = {
      AppLindin_url: linkedinUrlStatus.error,
      startupwebsite: startupwebsiteStatus.error,
      startup_video_url: startupUrlStatus.error,
      current_revenue: currentrevenueStatus.error,

      hasErrors:
      linkedinUrlStatus.hasError||
      startupwebsiteStatus.hasError||
      startupUrlStatus.hasError||
      currentrevenueStatus.hasError,

    };
    
    return formStatus;
  },
  validateStep4: (params) => {
    const { offered_startup, problem_solved } = params;
    let formStatus = {};
    const offeredstartupStatus = validate100TextArea(
      offered_startup,
      "*Please Enter Services Offered by Startup"
    );
    const problemsolvedStatus = validate100TextArea(
      problem_solved,
      "*Please Enter Problem Solved by Startup"
    );

    formStatus = {
      offeredstartupStatus: offeredstartupStatus.error,
      problemsolvedStatus: problemsolvedStatus.error,
      hasErrors: offeredstartupStatus.hasError || problemsolvedStatus.hasError,
    };
    
    return formStatus;
  },
  validateStep5: (params) => {
    const { whyneedMentorship, expected_outcome } = params;
    let formStatus = {};
    const whyneedMentorshipStatus = validate100TextArea(
      whyneedMentorship,
      "*Please Enter Why You Need Mentorship"
    );
    const expected_outcomeStatus = validate100TextArea(
      expected_outcome,
      "*Please Enter Expected Outcomes from Mentorship Sessions"
    );

    formStatus = {
      whyneedMentorshipStatus: whyneedMentorshipStatus.error,
      expectedoutcomeStatus: expected_outcomeStatus.error,
      hasErrors:
        whyneedMentorshipStatus.hasError || expected_outcomeStatus.hasError,
    };
    return formStatus;
  },

  validateStep6: (params) => {
    //
    const {
      // sector,
      // preferedsectormentor,
      industrydata,
      subindustry,
      preferedfuncsupport,
      subspecialization,
      currentstage,
      disclaimer,
      // preferredStage,
    } = params;
    let formStatus = {};
    // const preferedsectormentorStatus = validateSelectField(
    //   preferedsectormentor,
    //   "*Please Select Prefered Sector Of Mentor"
    // );
    // const SectorStatus = validateName(sector, "Please Enter sector");
    const IndustryStatus = validateSelectField(
      industrydata,
      "*Please Select Industry"
    );

    const subindustryStatus = validateSelectFieldMulti(
      subindustry,subspecialization,
      "*Please Select Industry / Sector - Keywords"
    );
    const preferedfuncsupportStatus = validateSelectField(
      preferedfuncsupport,
      "*Please Select function of Support"
    );
    const subspecializationStatus = validateSelectFieldMulti(
      subspecialization,subindustry,
      "*Please Select Function - Keywords"
    );
    const StageStatus = validateSelectField(
      currentstage,
      "*Please Select Stage"
    );
    const disclaimerStatus = validateDisclaimer(disclaimer);
    // const preferredStageStatus = validateSelectField(
    //   preferredStage,
    //   "*Please Select Prefered Stage Of The Startup"
    // );

    formStatus = {
      // preferedsectormentor: preferedsectormentorStatus.error,
      // sector: SectorStatus.error,
      industrydata: IndustryStatus.error,
      subindustry: subindustryStatus.error,
      preferedfuncsupport: preferedfuncsupportStatus.error,
      subspecialization: subspecializationStatus.error,
      currentstage: StageStatus.error,
      disclaimer: disclaimerStatus.error,
      // preferredStage: preferredStageStatus.error,
      hasErrors:
        // SectorStatus.hasError ||
        IndustryStatus.hasError ||
        // preferedsectormentorStatus.hasError ||
        subindustryStatus.hasError ||
        preferedfuncsupportStatus.hasError ||
        subspecializationStatus.hasError ||
        StageStatus.hasError ||
        disclaimerStatus.hasError,
      // preferredStageStatus.hasError,
    };
    return formStatus;
  },

  // validateStep7: (params) => {
  //   //
  //   const {
  //     // uploadResume,

  //   } = params;
  //   let formStatus = {};
  //   // const uploadResumeStatus = validateFile(uploadResume,"Please Select Resume");

  //   formStatus = {
  //     // uploadResume: uploadResumeStatus.error,

  //     // hasErrors:
  //     //   uploadResumeStatus.hasError||
  //     //   startupUrlStatus.hasError || disclaimerStatus.hasError,
  //   };
  //   
  //   return formStatus;
  // },
};
